<ng-container *ngIf="showMessage && publishReason">
    <div class="message-container" *ngIf="showPendingMessage()">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />

            <div class="message-title" data-cy="vessel-folder-req-approval-approver-notif-msg-header">
                {{
                    'vessel.page.message.pending.title'
                        | translate
                            : {
                                  userName: publishReason.ownerName,
                                  version: vessel.projectVersion,
                              }
                }}
            </div>
            <div class="reason-container">
                <div class="reason-title" data-cy="vessel-folder-req-approval-approver-notif-msg-body-reason-header">
                    {{ 'vessel.page.message.pending.reason.title' | translate }}
                </div>
                <div class="reason-string" data-cy="vessel-folder-req-approval-approver-notif-msg-body-reason-text">
                    {{ reasonString }}
                </div>
            </div>

            <div
                *ngIf="publishReason.reason.comment"
                class="reason-container reason-title"
                data-cy="vessel-folder-req-approval-approver-notif-msg-body-comment-header">
                {{ 'vessel.page.message.pending.reason.comment.title' | translate }}
            </div>

            <div
                *ngIf="publishReason.reason.comment"
                class="text-message reason-string"
                data-cy="vessel-folder-req-approval-approver-notif-msg-body-comment-text">
                {{ publishReason.reason.comment }}
            </div>
        </div>

        <div class="buttons-container">
            <div
                class="reject button"
                data-cy="vessel-folder-req-approval-approver-reject-button"
                (click)="openRejectDialog()">
                {{ 'vessel.page.message.pending.button.reject' | translate }}
            </div>
            <div
                class="approve button"
                data-cy="vessel-folder-req-approval-approver-approve-button"
                (click)="openApproveDialog()">
                {{ 'vessel.page.message.pending.button.approve' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showApprovedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title" data-cy="vessel-folder-req-approval-requester-approve-notif-msg-header">
                {{
                    'vessel.page.message.approved.title'
                        | translate
                            : {
                                  userName: publishReason.approverName,
                                  version: vessel.projectVersion,
                              }
                }}
            </div>
            <div class="text-message" data-cy="vessel-folder-req-approval-requester-approve-notif-msg-body">
                {{ 'vessel.page.message.approved.message' | translate }}
            </div>
        </div>

        <div class="buttons-container">
            <div
                class="approved-button"
                data-cy="vessel-folder-req-approval-requester-approve-notif-msg-unlock-btn"
                (click)="unlockVessel()">
                {{ 'vessel.page.button.unlock' | translate }}
            </div>
            <div
                class="approved-button publish"
                data-cy="vessel-folder-req-approval-requester-approve-notif-msg-publish-btn"
                (click)="publishProject()">
                {{ 'vessel.page.button.publish' | translate }}
            </div>
        </div>
    </div>

    <div *ngIf="showApprovedMessageApprover()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title" data-cy="vessel-folder-req-approval-approver-approve-notif-msg-header">
                {{ 'vessel.page.message.supervisor.approved.title' | translate: { version: vessel.projectVersion } }}
            </div>
        </div>
    </div>

    <div *ngIf="showRejectedMessage()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title" data-cy="vessel-folder-req-approval-requester-reject-notif-msg-header">
                {{
                    'vessel.page.message.rejected.title'
                        | translate
                            : {
                                  userName: publishReason.approverName,
                                  version: vessel.projectVersion,
                              }
                }}
            </div>
            <div class="text-message" data-cy="vessel-folder-req-approval-requester-reject-notif-msg-body">
                {{ 'vessel.page.message.rejected.message' | translate }}
            </div>
            <div class="buttons-container">
                <div
                    class="button"
                    data-cy="vessel-folder-req-approval-requester-reject-notif-msg-btn"
                    (click)="hideRejectedMessage()">
                    {{ 'vessel.page.message.rejected.button.close' | translate }}
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="showRejectedMessageApprover()" class="message-container">
        <div class="text-container">
            <mat-icon svgIcon="approval" class="approval-icon" />
            <div class="message-title" data-cy="vessel-folder-req-approval-approver-reject-notif-msg-header">
                {{ 'vessel.page.message.supervisor.rejected.title' | translate: { version: vessel.projectVersion } }}
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="showAfterApprovedMessage">
    <div class="message-container">
        <div class="text-container">
            <mat-icon
                svgIcon="spaceship"
                class="approval-icon"
                data-cy="vessel-folder-publish-version-notification-message-icon" />
            <div class="message-title" data-cy="vessel-folder-publish-version-notification-message-header">
                {{ 'vessel.page.message.after-approved.title' | translate }}
            </div>
            <div class="text-message" data-cy="vessel-folder-publish-version-notification-message-body">
                {{ 'vessel.page.message.after-approved.message' | translate }}
            </div>
        </div>

        <div class="buttons-container">
            <div
                class="approved-button"
                data-cy="vessel-folder-publish-version-notification-message-btn"
                (click)="hideMessage()">
                {{ 'vessel.page.message.after-approved.button.close' | translate }}
            </div>
        </div>
    </div>
</ng-container>
